var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 3.000000)",
    fill: "#7F8D9A",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1602,15.7703 L4.1802,15.7703 L3.3802,6.2803 L12.9402,6.2803 L12.1602,15.7703 Z M6.0702,4.6793 L10.2002,4.6793 L10.2002,2.5993 L6.0702,2.5993 L6.0702,4.6793 Z M15.4302,4.6793 L11.8002,4.6793 L11.8002,1.8903 C11.8002,1.4003 11.4102,0.9993 10.9102,0.9993 L5.3602,0.9993 C4.8702,0.9993 4.4702,1.4003 4.4702,1.8903 L4.4702,4.6793 L0.8002,4.6793 C0.3602,4.6793 0.0002,5.0403 0.0002,5.4803 C0.0002,5.9193 0.3602,6.2803 0.8002,6.2803 L1.7702,6.2803 L2.6002,16.0403 C2.6702,16.7903 3.3002,17.3703 4.0602,17.3703 L12.2902,17.3703 C13.0502,17.3703 13.6802,16.7903 13.7402,16.0303 L14.5402,6.2803 L15.4302,6.2803 C15.8702,6.2803 16.2302,5.9193 16.2302,5.4803 C16.2302,5.0403 15.8702,4.6793 15.4302,4.6793 L15.4302,4.6793 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.22d98492.svg";
export { ForwardRef as ReactComponent };